function close_upload_cta(){	
	$.ajax( {
        url: '/first_visit_cta',
        type: 'post',        
        success: function( $data ) { 
           
        },
        error: function( response ) {

        }
    });
	$('body').removeClass('show-first_upload_cta');
	setTimeout(function(){
		$('.upload_cta_overlay').remove();
		$('.first_upload_cta').remove();
	},500);
}